// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"809":"users","854":"widgets","966":"login"}[chunkId] + "." + {"809":"7c936f2b","854":"9969d1a2","966":"90a11e31"}[chunkId] + ".js";
};